import type { ChunkDetailResponse } from "@/apis/compare/types";
import {
  buildDsdDlRegionViews,
  buildDsdLineItemRegionViews,
  buildDsdMemberRegionViews,
} from "@/components/ixd-dsd-compare/dsd-region-views";
import type { ReadonlyCompareSectionData } from "./readonly-compare-section";

/** 대사 chunk 상세 응답 → 읽기 전용 섹션 입력. 라이브 다운로드 빌더와 같은 변환이다. */
export const buildReadonlyCompareSection = (
  detail: ChunkDetailResponse,
): ReadonlyCompareSectionData => ({
  id: detail.dsdChunk.id,
  title: detail.dsdChunk.title,
  dsdSubChunks: detail.dsdChunk.subChunks,
  ixdChunks: detail.ixdChunks,
  dsdHeaderTags: detail.dsdHeaderTags,
  dlRegions: buildDsdDlRegionViews(detail.dsdDlRegions, detail.ixdChunks),
  periodRegions: detail.dsdPeriodRegions ?? null,
  lineItemRegions: buildDsdLineItemRegionViews(
    detail.dsdLineItemRegions,
    detail.dsdDlRegions,
    detail.ixdChunks,
  ),
  memberRegions: buildDsdMemberRegionViews(
    detail.dsdMemberRegions,
    detail.dsdDlRegions,
    detail.ixdChunks,
  ),
});
